/**
 * global-v2.js
 * 依赖: jQuery, global.js（ModalController 用于 global-modal）
 */

// 弹窗控制器（global-modal-v2，逻辑与 global-modal-v2.liquid 内联版一致）
class ModalControllerV2 {
  #modals = new Map();

  constructor() {
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const openModals = Array.from(document.querySelectorAll('global-modal-v2[data-is-open]'))
        .filter((modal) => modal.isOpen)
        .sort((a, b) => b.level - a.level);

      openModals[0]?.close();
    });
  }

  register(modalId, { onOpen, onClose } = {}) {
    const modal = document.querySelector(`global-modal-v2[data-modal-id="${modalId}"]`);
    if (!modal) return;

    if (onOpen) {
      modal.addEventListener('modal-opened', (event) => onOpen(event.detail.wrapperEle));
    }
    if (onClose) {
      modal.addEventListener('modal-closed', (event) => onClose(event.detail.wrapperEle));
    }

    this.#modals.set(modalId, modal);
    return modal;
  }

  getModal(modalId) {
    return this.#modals.get(modalId);
  }

  open(modalId) {
    const modal =
      this.#modals.get(modalId) ||
      document.querySelector(`global-modal-v2[data-modal-id="${modalId}"]`);
    if (!modal) return;
    this.#modals.set(modalId, modal);
    modal.open();
  }

  close(modalId) {
    const modal =
      this.#modals.get(modalId) ||
      document.querySelector(`global-modal-v2[data-modal-id="${modalId}"]`);
    modal?.close();
  }
}

/**
 * 在不改 global.js / liquid 的前提下，让 `new ModalController()` 自动支持 global-modal-v2
 */
function patchModalControllerForV2() {
  if (typeof ModalController === 'undefined') return;

  const modalControllerV2 = new ModalControllerV2();

  const isV2Modal = (modalId) =>
    Boolean(document.querySelector(`global-modal-v2[data-modal-id="${modalId}"]`));

  const originalRegister = ModalController.prototype.register;
  const originalGetModal = ModalController.prototype.getModal;
  const originalOpen = ModalController.prototype.open;
  const originalClose = ModalController.prototype.close;

  ModalController.prototype.register = function (modalId, options = {}) {
    if (isV2Modal(modalId)) {
      return modalControllerV2.register(modalId, options);
    }
    return originalRegister.call(this, modalId, options);
  };

  ModalController.prototype.getModal = function (modalId) {
    if (isV2Modal(modalId)) {
      return modalControllerV2.getModal(modalId);
    }
    return originalGetModal.call(this, modalId);
  };

  ModalController.prototype.open = function (modalId) {
    if (isV2Modal(modalId)) {
      return modalControllerV2.open(modalId);
    }
    return originalOpen.call(this, modalId);
  };

  ModalController.prototype.close = function (modalId) {
    if (isV2Modal(modalId)) {
      return modalControllerV2.close(modalId);
    }
    return originalClose.call(this, modalId);
  };
}

patchModalControllerForV2();

(function () {
  function hideSiteHeader() {
    var headerContainer = document.querySelector('#lt-header-v2');
    var headerV2 = document.querySelector('.header-v2');
    if (!headerContainer) return;
    if (headerV2) {
      headerV2.style.top = '';
      headerV2.style.position = '';
    }
    headerContainer.setAttribute('data-scrollshow', 'false');
  }

  $(function () {
    window.litime.hideSiteHeader = hideSiteHeader;
    /**
     * global-review-tab-trigger
     * 点击后跳转到 product-tabs-content-v2 的 REVIEW Tab
     */
    $(document).on('click', '.global-review-tab-trigger', function (e) {
      e.preventDefault();

      var tabsRoot = document.querySelector('product-tabs-content-v2');
      var reviewLink = tabsRoot && tabsRoot.querySelector('.product-tabs-content-v2__link[data-tab-type="REVIEW"]');

      if (!reviewLink) {
        console.warn('[global-review-tab-trigger] REVIEW tab link not found');
        return;
      }

      reviewLink.click();
    });

    function isAddToCartLoading(trigger) {
      var innerBtn = trigger.querySelector('.global-button-v2');
      if (innerBtn) {
        return innerBtn.getAttribute('data-loading') === 'true';
      }
      return trigger.dataset.loading === 'true';
    }

    function setAddToCartLoading(trigger, loading) {
      var innerBtn = trigger.querySelector('.global-button-v2');
      if (innerBtn) {
        innerBtn.setAttribute('data-loading', loading ? 'true' : 'false');
        return;
      }
      trigger.dataset.loading = loading ? 'true' : 'false';
      if (loading) {
        trigger.setAttribute('aria-disabled', 'true');
      } else {
        trigger.removeAttribute('aria-disabled');
      }
    }

    async function openProductModalV2WithLoading(shopNowBtn, productHandle) {
      try {
        await window.litime.openProductModalV2(productHandle);
      } catch (err) {
        console.error('[global-add-to-cart-trigger] open modal v2 error:', err);
      } finally {
        setAddToCartLoading(shopNowBtn, false);
      }
    }

    $(document).on('click', '.global-add-to-cart-trigger', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (isAddToCartLoading(this)) return;

      var shopNowBtn = this;
      var variantCount = parseInt(shopNowBtn.dataset.variantCount, 10);
      var productHandle = shopNowBtn.dataset.productHandle;

      if (variantCount > 1) {
        setAddToCartLoading(shopNowBtn, true);

        if (window.litime.version === 'v2' && typeof window.litime.openProductModalV2 === 'function') {
          openProductModalV2WithLoading(shopNowBtn, productHandle);
        } else {
          openQuickView(shopNowBtn, productHandle);
        }

        return;
      }

      var variantId = shopNowBtn.dataset.variantId;
      var quantity = shopNowBtn.dataset.quantity || '1';

      setAddToCartLoading(shopNowBtn, true);

      var sections = [getMiniCartSectionId(), 'cart-icon-bubble'].filter(Boolean);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) || 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (parsedState) {
          if (parsedState.status === 422) {
            window.litime.showToast(parsedState.description, 'error');
          } else {
            if (window.location.pathname === '/cart') {
              window.scrollTo(0, 0);
              window.location.reload();
            } else if (
              typeof (document.querySelector('global-mini-cart-v2, cart-drawer') || {})?.renderContents === 'function'
            ) {
              (document.querySelector('global-mini-cart-v2, cart-drawer') || {}).renderContents(parsedState);
            }
          }
        })
        .catch(function (err) {
          console.error('[global-add-to-cart-trigger] add to cart error:', err);
        })
        .finally(function () {
          setAddToCartLoading(shopNowBtn, false);
        });
    });

    function openQuickView(shopNowBtn, productHandle) {
      window.litime.disableScroll();
      fetch('/products/' + productHandle + '?view=modal')
        .then(function (response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(function (responseText) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(responseText, 'text/html');
          doc.querySelectorAll('script').forEach(function (s) {
            s.textContent = '';
          });
          var quickshopPopup =
            (doc.getElementById('quickshop-popup') && doc.getElementById('quickshop-popup').innerHTML) || '';
          $('#global-product-card-popup').html(quickshopPopup);
          setAddToCartLoading(shopNowBtn, false);
          try {
            var popupEl = $('#global-product-card-popup').find('product-detail-data-popup')[0];
            if (popupEl && popupEl.applyPreferentialMode) {
              popupEl.applyPreferentialMode();
            }
          } catch (e) {
            console.warn('[global-add-to-cart-trigger] set preferential data failed:', e);
          }
        })
        .catch(function (err) {
          setAddToCartLoading(shopNowBtn, false);
        });
    }

    window.litime && (window.litime.hideSiteHeader = hideSiteHeader);
    window.hideSiteHeader = hideSiteHeader;
  });
})();
